import { render, staticRenderFns } from "./header.vue?vue&type=template&id=4d8346aa"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/whitewe_jisheng-mes-ui_CPvN/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d8346aa')) {
      api.createRecord('4d8346aa', component.options)
    } else {
      api.reload('4d8346aa', component.options)
    }
    module.hot.accept("./header.vue?vue&type=template&id=4d8346aa", function () {
      api.rerender('4d8346aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home-page/components/header.vue"
export default component.exports